module.exports = {
  email: 'scott.grivner@gmail.com',

  socialMedia: [
    {
      name: 'AppStore',
      url: 'https://apps.apple.com/app/id6450848695',
    },
    {
      name: 'GitHub',
      url: 'https://github.com/scottgriv',
    },
    {
      name: 'StackOverflow',
      url: 'https://stackoverflow.com/u/3092847',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/scottgrivner/',
    },
    {
      name: 'Medium',
      url: 'https://medium.com/@scottgrivner',
    },
    {
      name: 'Goodreads',
      url: 'https://goodreads.com/scottgrivner',
    },
    {
      name: 'Twitter',
      url: 'https://x.com/scottgriv',
    },
    {
      name: 'Codepen',
      url: 'https://codepen.io/scottgriv',
    },
    {
      name: 'Calendly',
      url: 'https://calendly.com/scottgrivner',
    },
    {
      name: 'RSS',
      url: 'https://medium.com/feed/@scottgrivner',
    },
    /*
    {
      name: 'Instagram',
      url: '',
    }
    */
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'Publications',
      url: '/#publications',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
